/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';
import noop from 'lodash/noop';

import { ContentModuleModal, SortableList } from '@molecules';
import { Typography } from '@atoms';
import { NO_MARGIN_BOTTOM } from '@constants';
import { getImage } from '@utils/media';

import Form from '../Form';

import ProfileForm from './ProfileForm';
import ProfileItem from './ProfileItem';
import CarouselItem from './Item';
import { PROFILES, PROFILE_INITS, FORM_PANEL } from './constant';
import s from './styles.module.less';

const TabbedModule = ({ visible = true, previewImg, onSubmit, hide, onDelete, initialValues: initData, errors }) => {
  const [form] = Form.useForm(FORM_PANEL);

  const initialValues = React.useMemo(() => form.deserialize(initData || PROFILE_INITS), [form, initData]);

  const [slides, setSlides] = React.useState(initialValues[PROFILES.name]);

  const syncSlides = React.useCallback(
    (_slides) => {
      form.setFields([{ name: PROFILES.name, value: _slides }]);
      setSlides(_slides);
    },
    [form, setSlides],
  );

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleAdd = React.useCallback((slide) => syncSlides([slide, ...(form.getFieldValue(PROFILES.name) || [])]), [
    form,
    syncSlides,
  ]);

  return (
    <ContentModuleModal
      okText={onDelete ? 'SAVE CHANGES' : 'ADD PROFILE PANEL'}
      title="Profiles module"
      heroImageSrc={previewImg}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      visible={visible}
      errors={errors}
    >
      <Typography.Title level={3}>Add a profile</Typography.Title>
      {visible && <ProfileForm onSubmit={handleAdd} className={s.addForm} initKey="mainForm" />}
      <SortableList
        style={NO_MARGIN_BOTTOM}
        label="Current profiles"
        onChange={syncSlides}
        withPlaceholder
        value={slides}
        withCount
      >
        {(value, { edit, isEdit, save, buttons }) =>
          isEdit ? (
            <ProfileForm onSubmit={save} initialValues={value} buttons={buttons} initKey={slides.indexOf(value)} />
          ) : (
            <ProfileItem image={getImage(value, 'image')} description={value.title} handleEdit={edit}>
              {value?.name}
            </ProfileItem>
          )
        }
      </SortableList>

      <Form onSerializedFinish={handleSubmit} initialValues={initialValues} layout="vertical" form={form}>
        <Form.List className={s.listItem} {...PROFILES}>
          {noop}
        </Form.List>
      </Form>
    </ContentModuleModal>
  );
};

TabbedModule.Item = CarouselItem;

export default TabbedModule;
